import styled from 'styled-components'

export const StyledShareButton = styled.button`
    ${p => p.theme.utils.flex({ ai: 'center', jc: 'flex-start' })};
    font-size: 16px;
    margin-left: auto;

    span:last-child {
        margin-top: -6px;
        color: ${p => p.theme.utils.toRgba(p.theme.playerIconsColor, 0.6)};
    }
`
